import { Inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { CORE_CONFIGURATION } from '../configuration';
import { LoggerService } from './logger.service';
import {
  AUTH_VALUE,
  CLIENT_ID,
  DOMAIN,
  HEADER_API,
  HEADER_AUTH,
  HEADER_AUTH_TOKEN,
  HEADER_AUTH_TOKEN_AWS,
  HEADER_AWS_API,
  HEADER_CLIENT_ID,
  HEADER_DEVICE_UA,
  HEADER_DOMAIN,
  HEADER_INSTALLATION_ID,
  HEADER_NETWORK_INFO,
} from '../constants';
import { StorageService } from '../storage/storage.service';
import { SessionState } from '../session/session.state';
import { SessionStateModel } from '../session/session.model';
import { ErrorsService } from '../errors/errors.service';
import { WindowService } from './window.service';
import { compareVersion } from '../util.class';

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {
  constructor(
    @Inject(CORE_CONFIGURATION) private config,
    private logger: LoggerService,
    private errorService: ErrorsService,
    private storage: StorageService,
    private store: Store,
    private window: WindowService,
  ) {
  }

  /* eslint-disable */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const session: SessionStateModel = this.store.selectSnapshot(SessionState);

    let NoSetheaders: HttpHeaders = req.headers;

    let NoSetwithCredentials = null;

    const { headers, withCredentials } = this.setHeaders(NoSetheaders, req, session, NoSetwithCredentials);
    
    const request = req.clone({ headers, withCredentials});

    this.logger.group('HTTP Client: Request', request);

    return this.handleResponse(next, request);
  }

  private setHeaders(headers: HttpHeaders, req: HttpRequest<any>, session: SessionStateModel, withCredentials: any) {
    if (headers.has(HEADER_API)) {
      headers = headers
        .set('Content-Type', 'application/json')
        .set(HEADER_DEVICE_UA, headers.has(HEADER_AWS_API) ? this.deviceUserAgentAWS() : this.deviceUserAgent())
        .set(HEADER_AUTH, AUTH_VALUE)
        .delete(HEADER_API)
        .delete(HEADER_AWS_API);

      // only for login in browser
      if (req.url === '/WebbusLogin/v1/profile' ||
        req.url === '/JsLogin/v3/anonymousLogin' ||
        req.url === '/JsLogin/v3/loggedLogin' ||
        req.url === '/authorization/v1/anonymous' ||
        req.url === '/authorization/v1/login') {
        headers = headers.set(HEADER_DOMAIN, DOMAIN);
      }

      //only for get province
      if(!!session.device.installationId
        && session.device.installationId!=='undefined'
          && session.device.installationId!=='null'){
      headers = headers.set(HEADER_INSTALLATION_ID, session.device.installationId);
    }
    else{
      headers = headers.set(HEADER_INSTALLATION_ID, '60cc903311c912e1244038c5d3bcac90');
    }

      if (!headers.has(HEADER_CLIENT_ID)) {
        headers = headers.set(HEADER_CLIENT_ID, CLIENT_ID);
      }

      if (session.auth.token &&
        !req.url.includes('/configuration/v1')) {
        headers = headers.set(HEADER_AUTH_TOKEN, session.auth.token);
      }

      if (session.auth.tokenExchangeMap &&
        (session?.device?.appVersion === 'local' || (session?.device?.appVersion)) &&
        !req.url.includes('/configuration/v1')) {
        Object.keys(session.auth.tokenExchangeMap)?.forEach(key => {
          // SE STO ANDANDO SU AWS, AGGIUNGI L'HEADER
          // ALTRIMENTI NON AGGIUNGERE L'HEADER
          if (!req.url.includes('dxl.vodafone.it') && !req.url.includes('dxl-pre.vodafone.it')) {
              const headerKey = key;
              const headerValue = session.auth.tokenExchangeMap[key];
            headers = headers.set(headerKey , headerValue);
          }

          if (compareVersion(session?.device?.appVersion, '7.0.0') < 0) {
            try {
              const temporary_customer_identification = document.cookie.split('vf-a-customer-identification=')[1] ?? '';
              headers.set('vfa-customer-identification', temporary_customer_identification);
            } catch {
              console.error('vf-a-customer-identification is not found in the cookie');
            }
          }

        });
      }

      if (session?.device?.appVersion === 'local') {
        headers.set('Cookie',  "vf-a-customerrefresh=15894830d6d29864ba5c936299fdb712; vf-a-customer-identification=eyJraWQiOiJ2ZmE6YXV0aGVudGljYXRvciIsInR5cCI6IkpXVCIsImFsZyI6IlJTNTEyIn0.eyJhdWQiOiJkeGwiLCJzdWIiOiJleUpoZEhSeWFXSjFkR1Z6SWpwN0luVnpaWEp1WVcxbElqb2laRzl0WVc1bmJ6azNNeUlzSW5CaGNuUjVTV1FpT2lKSlZEVXdOalExT0RJNUluMTkiLCJzY29wZSI6ImUzMD0iLCJpc3MiOiJhdXRoZW50aWNhdG9yIiwiY2xhaW1zIjp7Im1hcmtldCI6ImJ1c2luZXNzIiwic2VjdXJpdHlMZXZlbCI6IjMwIiwidXNlcmFzc2V0LnR5cGUuMCI6Im1vYmlsZSIsImRlbGVnYXRpb25DdXN0b21lckNvZGUiOiI2LjIzNzk3MSIsInJvbGUiOiJtYXN0ZXIiLCJ1c2VyQ3VzdG9tZXJDb2RlIjoiNi4yMzc5NzEuMDAuMDAuMTI4MyIsInByb2ZpbGVJZCI6IkJVU0lORVNTX01BU1RFUl9SRUZFUkVOVCIsInVzZXJhc3NldC5pZC4wIjoiMzQyMTIxMDA0NSIsImN1c3RvbWVySWQiOiIxNzI4NDYzMyIsImZhY3RvciI6InNtcyJ9LCJleHAiOjE3NDY3MTE4MDEsInNlY3JldHMiOm51bGwsImp0aSI6IjE4OGQ2ZTZlNDUwMzUxN2I2YjE2M2RjNzlhNjI1Mjg4In0.NttSvD4GcZ75cq2EGt4vdEtrpYLBupfVd1kj0AaUg8iCpwZro1kS3X58FMn2fM3IfAabls8NM2h0V0wLxWs1M5F8kQh9EfFkcksvoNUNer0OD0e1zMN4naqZ3-2KNLHFkshVy_6ohVBcqfOfNriA4n1UYpwPSRWUnDln6Vl6mTflgc3F7PwUw0rhuwoDO98QbtZaeHdD8Bu9btMX34GoOwmkA9oOdQWZOWGwwYBGz0Fx9uHnFH03D9MHysZpflXoj09RA8aNzyC8NiY1PLZx6reaRmRx9iB14fgl3XZQkF6v75LYKZhKAvN0NPht5OBRSYvjIxYJsh-7TTp-CPSCGUpO-ljgDtxS8KXAwNNWIO9u8lCZmYq7feYHmx_m-2duonIR46lt4G8i7O0DPwuxV8owxNH_gHWDBEJk81_F7TKpGBgKzUn8hzbiRwwUz0q5iYZOp_KQQuh5K9qy1xlHeYyEyuguujWSol4mDhDE5raXI0jT6Qo0hhnAC-zbwn5D45ILJxtAeCsFE7FZme2kAA-EScY7Fe7qeveWRn3MqbB6esIZT7Ch2JDQFfVg0dJRBvdNn7EYKjeh8npVOTzGQ9jPOKiBwdbGd28kgXjDvZah-pCijOIekd9Ppv_R3m9eB7mysRFFqZHq-EcSFpOhqYg3Qt01M3j3akRXX4Kwbdc; ObSSOCookie=IpKSuZ4k4+5JPz5uNOx0fsREZstx/yFFZindUG0p8riuagb7x9MOwRjZ4iYSpOgiPBEmri4OL27kkgppCcVqyPEKitEP6PTujvXtZlij5RsIoOTMlv/cHVXQ12kXV/u3cusEHJncJ3+RxR2x2Cupx2srZV8u868NqCuAIqNdRKvvFzppt/QU5lci6hGI9fz4aJbACOgopNzksSAha62AdgMQSX6pR7R1BXAB+VVymgLXgl/9arBV+FcKRV6vXoB3p8y/3c1H8AJ7W5ACtOm9GLvwZEeBD6CdWExD3ds9aP8PzV70BRyib8O+mIuxZ2QPAg5XrikX66wpdwMru26GerKlONO/Flmwy2UbIWipXSU=; ");
      }

      if (!session.auth.tokenExchangeMap && (session?.device?.appVersion === "undefined" || (session?.device?.appVersion)) &&
        !req.url.includes('/configuration/v1')&&!req.url.includes('loginByCookie')) {
        const token_map = JSON.parse(localStorage.getItem('tokenExchangeMap'));
        Object.keys(token_map)?.forEach(key => {
          // SE STO ANDANDO SU AWS, AGGIUNGI L'HEADER
          // ALTRIMENTI NON AGGIUNGERE L'HEADER
          if (!req.url.includes('dxl.vodafone.it') && !req.url.includes('dxl-pre.vodafone.it')) {
            const headerKey = key;
            const headerValue = token_map[key];
            headers = headers.set(headerKey, headerValue);
          }
        })
      }



      if (session.device?.networkInfo) {
        headers = headers.set(HEADER_NETWORK_INFO, session.device.networkInfo);
      }

      if (req.url.indexOf('/auth/realms/app-br-snow/snow-session') >= 0) {
        headers = headers.delete(HEADER_INSTALLATION_ID);
        headers = headers.delete(HEADER_DEVICE_UA);
        headers = headers.delete(HEADER_NETWORK_INFO);
        withCredentials = true;
      }
    }
    return { headers, withCredentials };
  }

  private handleResponse(next: HttpHandler, request: HttpRequest<any>): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      filter((response) => response instanceof HttpResponse),
      map(
        (response: HttpResponse<any>) => {
          this.logger.group('HTTP Client: Response', response);

          if (response.status === 204 && response.body === null && request.method === 'POST') {
            response = response.clone({ status: 200, body: {} });
            this.logger.group('HTTP Client: Response CLONED! cause no-content (204) manage', response);
          }

          return response;
        },
        (error) => this.errorService.log(error).subscribe()
      )
    );
  }

  deviceUserAgent() {
    // TODO Android device user agent 'X-Device-User-Agent	MyVodafoneBusiness/android/s/9/6.2.0/3.0/custom/"samsung"/"SM-G960F"'
    // TODO Old FE device user agent 'MyVodafoneBusiness/android/s/1.0/6.2.0/1.0/custom/"Google"/"x86_64"';
    
    // MyVodafoneBusiness/android/s/11/6.14.0/2.75/store/"Xiaomi"/"Redmi Note 8"
    // MyVodafoneBusiness/ios/s/1.0/local/1.0/custom/Apple/x86_64
    
    // MyVodafoneBusiness/ios/s/11/6.14.0/2.75/store/"Apple"/"iPhone 10"

    const { device } = this.store.selectSnapshot(SessionState);

    const appName = 'MyVodafoneBusiness';
    const deviceFamily = this.window.isiOS() ? 'ios' : 'android';
    const deviceType = device?.deviceIsTablet ? 't' : 's';
    const appVersion = device?.appVersion || '6.2.0';
    const osVersion = '1.0'; // TODO like asis
    const somethingVersion = '1.0'; // TODO check this value now is like asis
    const factory = this.window.isiOS() ? 'Apple' : 'Google';
    const serialNumber = 'x86_64';

    return device?.deviceUserAgent
      ? this.window.decode(device.deviceUserAgent)
      : `${appName}/${deviceFamily}/${deviceType}/${osVersion}/${appVersion}/${somethingVersion}/custom/${factory}/${serialNumber}`;
  }

  
  deviceUserAgentAWS() {
    // MyVodafoneBusiness/ios/s/1.0/local/1.0/custom/Apple/x86_64 --> VECCHIO X-Device-User-Agent
    
    // MyVodafoneBusiness/android/s/11/6.14.0/2.75/store/"Xiaomi"/"Redmi Note 8"  --> NUOVO X-Device-User-Agent
    // MyVodafoneBusiness/ios/s/11/6.14.0/2.75/store/"Apple"/"iPhone 10"


    const { device } = this.store.selectSnapshot(SessionState);

    const appName = 'MyVodafoneBusiness';
    // const deviceFamily = this.window.isiOS() ? 'ios' : 'android';
    const deviceFamily = device.appPlatform ? 'ios' : 'android';
    const deviceType = device?.deviceIsTablet ? 't' : 's';
    const osVersion = '11'; 
    const appVersion = (device?.appVersion && device?.appVersion !== 'local') ? device?.appVersion : '6.14.0'; // device?.appVersion || '6.14.0';
    const somethingVersion = '2.75';
    const factory = device?.deviceVendor ?  `"${device.deviceVendor}"` :  '"Apple"';
    const deviceModel = device?.deviceModel ? `"${device.deviceModel}"` : '"iPhone 10"';

    return device?.deviceUserAgent
      ? this.window.decode(device.deviceUserAgent)
      : `${appName}/${deviceFamily}/${deviceType}/${osVersion}/${appVersion}/${somethingVersion}/store/${factory}/${deviceModel}`;
  }
}
